import { z } from "zod";

export const ReferralCodesCreateInTreeResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const ReferralCodesFastGenerateResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const ReferralCodesPositionalCodesResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export default ReferralCodesCreateInTreeResponse;
